import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ac0044',
    ecrans: ['00-2']
});

